import { render, staticRenderFns } from "./accommodationActionsType.vue?vue&type=template&id=23b36ddf&scoped=true"
import script from "./accommodationActionsType.vue?vue&type=script&lang=js"
export * from "./accommodationActionsType.vue?vue&type=script&lang=js"
import style0 from "./accommodationActionsType.vue?vue&type=style&index=0&id=23b36ddf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b36ddf",
  null
  
)

export default component.exports